import React from 'react';

interface Props {
  byteArray: number[];
  lang:string;
  domainName:string;
}

const FileDownloadComponent: React.FC<Props> = ({ byteArray, lang , domainName}) => {
  const handleDownload = () => {
    const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = domainName +'.'+ lang;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <button onClick={handleDownload}>Download model</button>
  );
};

export default FileDownloadComponent;
